module.exports = __webpack_public_path__ + "img/Aaryaduta-Website-Logo.ce83962e.png";